<template>
  <v-skeleton-loader :loading="loading" :types="skeleton" type="article, actions">
    <v-card class="elevation-1 mb-6 rounded-lg mt-0">
      <v-card-title class="pa-7">
        Hodnoty | Stěhování
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-7">
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="12" class="py-0">
                <div class="request-label">Kategorie</div>
                <div class="request-value mt-2">{{ value.type ? value.type.text : '-' }}</div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-skeleton-loader>
</template>
<script>
export default {
  name: 'OrderMoveDetail',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      order: {},
      loading: false,
      saving: false,
    }
  },
}
</script>
